import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="bg-white text-gray-900 p-8 max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold mb-6 text-blue-600">Privacy Policy for OP Game Tracker</h1>
      <p className="mb-4">Effective Date: May 02, 2025</p>

      <p className="mb-4">
        OP Game Tracker ("we", "our", or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website located at opgametracker.com (the "Site").
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">1. Information We Collect</h2>
      <p className="mb-2"><strong>a. Personal Information (only if voluntarily provided)</strong></p>
      <ul className="list-disc list-inside mb-4">
        <li>Email address (e.g., for newsletter signup or account creation)</li>
        <li>Username or profile data (if applicable)</li>
      </ul>
      <p className="mb-2"><strong>b. Non-Personal Information</strong></p>
      <ul className="list-disc list-inside mb-4">
        <li>Browser type and version</li>
        <li>Operating system</li>
        <li>Referring website</li>
        <li>Pages visited and time spent</li>
        <li>IP address (for security/log purposes)</li>
      </ul>
      <p className="mb-4">
        We use analytics tools such as Google Analytics to understand how visitors interact with the Site. This may include usage data and device information.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">2. How We Use Your Information</h2>
      <ul className="list-disc list-inside mb-4">
        <li>Provide and maintain our services</li>
        <li>Improve the performance and content of the Site</li>
        <li>Send occasional updates (only if you opt-in)</li>
        <li>Comply with legal obligations</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-6 mb-2">3. Cookies and Tracking Technologies</h2>
      <p className="mb-4">
        We use cookies and similar technologies to enhance your experience. Cookies may be used for:
      </p>
      <ul className="list-disc list-inside mb-4">
        <li>Website analytics</li>
        <li>Remembering preferences</li>
        <li>Personalized content and ads</li>
        <li>Third-party advertising (Google AdSense)</li>
      </ul>
      <p className="mb-4">
        You can adjust your browser settings to refuse cookies, but this may affect your use of the Site.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">4. Third-Party Advertising and Google AdSense</h2>
      <p className="mb-4">
        We use Google AdSense to display advertisements on our website. Google AdSense uses cookies and similar technologies to:
      </p>
      <ul className="list-disc list-inside mb-4">
        <li>Display personalized advertisements based on your interests</li>
        <li>Analyze website traffic and user behavior</li>
        <li>Provide relevant advertising content</li>
        <li>Measure the effectiveness of advertisements</li>
      </ul>
      <p className="mb-4">
        Google AdSense may collect and process the following information:
      </p>
      <ul className="list-disc list-inside mb-4">
        <li>Your IP address</li>
        <li>Browser type and version</li>
        <li>Pages you visit on our website</li>
        <li>Time spent on pages</li>
        <li>Click-through data for advertisements</li>
      </ul>
      <p className="mb-4">
        Google's use of advertising cookies enables it and its partners to serve ads to you based on your visits to our site and/or other sites on the internet. You may opt out of personalized advertising by visiting <a href="https://www.google.com/settings/ads" className="text-blue-600 hover:underline" target="_blank" rel="noopener noreferrer">Google Ads Settings</a>.
      </p>
      <p className="mb-4">
        For more information about how Google uses data when you use our site, please visit <a href="https://policies.google.com/technologies/ads" className="text-blue-600 hover:underline" target="_blank" rel="noopener noreferrer">Google's Privacy Policy</a>.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">5. Sharing of Information</h2>
      <p className="mb-4">
        We do not sell or rent your personal information. We may share data:
      </p>
      <ul className="list-disc list-inside mb-4">
        <li>With third-party service providers that help us operate the Site (e.g., analytics tools)</li>
        <li>When required by law or to protect rights and safety</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-6 mb-2">6. Data Security</h2>
      <p className="mb-4">
        We implement appropriate technical and organizational measures to protect your data from unauthorized access, loss, or misuse. However, no system is 100% secure.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">7. Children's Privacy</h2>
      <p className="mb-4">
        OP Game Tracker is not intended for use by children under the age of 13, and we do not knowingly collect personal information from children.
      </p>
      <p className="mb-4">
        That said, we understand that families may use our platform to explore upcoming and newly released games. To help parents and guardians make informed decisions, OP Game Tracker displays age ratings (such as ESRB or PEGI) when available. These ratings can serve as a helpful tool in determining whether a game is appropriate for younger audiences.
      </p>
      <p className="mb-4">
        We encourage parents to supervise their children's use of the internet and to use these age ratings to better control what content their children are exposed to.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">8. Changes to This Policy</h2>
      <p className="mb-4">
        We may update this policy periodically. Changes will be posted on this page with a revised effective date.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">9. Contact Us</h2>
      <p className="mb-2">
        If you have any questions about this Privacy Policy, you can contact us at:
      </p>
      <p className="mb-2">
        Email: <a href="mailto:contact@opgametracker.com" className="text-blue-400 hover:underline">contact@opgametracker.com</a>
      </p>
      <p>
        Website: <a href="https://opgametracker.com" className="text-blue-600 hover:underline">https://opgametracker.com</a>
      </p>
    </div>
  );
};

export default PrivacyPolicy;
